var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivateCabinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 6.5C6.5 5.46566 6.91089 4.47368 7.64228 3.74228C8.37368 3.01089 9.36566 2.6 10.4 2.6C11.4343 2.6 12.4263 3.01089 13.1577 3.74228C13.8891 4.47368 14.3 5.46566 14.3 6.5V9.1H6.5V6.5ZM3.9 9.1V6.5C3.9 4.77609 4.58482 3.12279 5.80381 1.90381C7.02279 0.684819 8.67609 0 10.4 0C12.1239 0 13.7772 0.684819 14.9962 1.90381C16.2152 3.12279 16.9 4.77609 16.9 6.5V9.1H19.5C19.8448 9.1 20.1754 9.23696 20.4192 9.48076C20.663 9.72456 20.8 10.0552 20.8 10.4V22.1C20.8 23.1343 20.3891 24.1263 19.6577 24.8577C18.9263 25.5891 17.9343 26 16.9 26H3.9C2.86566 26 1.87368 25.5891 1.14228 24.8577C0.410892 24.1263 0 23.1343 0 22.1V10.4C0 10.0552 0.136964 9.72456 0.380761 9.48076C0.624559 9.23696 0.955219 9.1 1.3 9.1H3.9ZM11.7 17.55C11.7 17.0328 11.9054 16.5368 12.2711 16.1711C12.6368 15.8054 13.1328 15.6 13.65 15.6H13.663C14.1802 15.6 14.6762 15.8054 15.0419 16.1711C15.4076 16.5368 15.613 17.0328 15.613 17.55V17.563C15.613 18.0802 15.4076 18.5762 15.0419 18.9419C14.6762 19.3076 14.1802 19.513 13.663 19.513H13.65C13.1328 19.513 12.6368 19.3076 12.2711 18.9419C11.9054 18.5762 11.7 18.0802 11.7 17.563V17.55Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateCabinIcon);
export default __webpack_public_path__ + "static/media/private-cabin-icon.043681ddf53eeb16b7f94c0ab5e9226d.svg";
export { ForwardRef as ReactComponent };